// 登录态本地存储：管理端 token 与用户信息
const TOKEN_KEY = 'qywx_admin_token'
const USER_KEY = 'qywx_admin_user'
// 存档查询页共享的「当前接入方」选择（含 appId/appSecret，仅本地会话内使用）
const ARCHIVE_APP_KEY = 'qywx_archive_app'

export function getToken () {
    return localStorage.getItem(TOKEN_KEY)
}

export function setToken (token) {
    localStorage.setItem(TOKEN_KEY, token || '')
}

export function removeToken () {
    localStorage.removeItem(TOKEN_KEY)
}

export function getUserInfo () {
    const value = localStorage.getItem(USER_KEY)
    if (!value) return null
    try {
        return JSON.parse(value)
    } catch (error) {
        return null
    }
}

export function setUserInfo (userInfo) {
    localStorage.setItem(USER_KEY, JSON.stringify(userInfo || {}))
}

export function removeUserInfo () {
    localStorage.removeItem(USER_KEY)
}

export function getArchiveApp () {
    const value = sessionStorage.getItem(ARCHIVE_APP_KEY)
    if (!value) return null
    try {
        return JSON.parse(value)
    } catch (error) {
        return null
    }
}

export function setArchiveApp (app) {
    if (app) {
        sessionStorage.setItem(ARCHIVE_APP_KEY, JSON.stringify(app))
    } else {
        sessionStorage.removeItem(ARCHIVE_APP_KEY)
    }
}

export function clearAuthStorage () {
    removeToken()
    removeUserInfo()
}
